import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import ManagedPhoto from '../../../../../components/UserPortal/Locker/PhotoVideo/ManagedPhoto'
import ParticipationPhotoUploader from '../../../../../components/UserPortal/Locker/PhotoVideo/ParticipationPhotoUploader'

class LockerPhotosManager extends Component {
  static propTypes = {
    updateParticipation: PropTypes.func.isRequired,
    participation: PropTypes.object.isRequired
  }

  render() {
    const { participation, updateParticipation, setFlashMessage } = this.props
    const { id, photos } = participation

    return(
      <div className="locker-photos-manager">
        <p className="note">
          To upload a photo, click an empty photo container below and choose a file. Photos are automatically saved after upload. Max file size is 500kb.
        </p>

        <ul className="managed-photo-list">
          {
            photos.map((photo, index) => (
              <li key={index} className="managed-photo-list-item">
                <ManagedPhoto
                  {...photo}
                  updateParticipation={updateParticipation}
                />
              </li>
            ))
          }

          <li className="managed-photo-list-item">
            <ParticipationPhotoUploader
              participationID={id}
              updateParticipation={updateParticipation}
              setFlashMessage={setFlashMessage}
            />
          </li>
        </ul>
      </div>
    )
  }
}

export default LockerPhotosManager



// WEBPACK FOOTER //
// ./src/screens/UserPortal/Locker/LockerScreens/LockerPhotosManager/LockerPhotosManager.js